import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import icon from '../../assets/svg/arogya-bee-doctor-pro-logo.jpg';
import { accountDeletion } from "../../service/api.service";

import './DoctorAccountDeletionInfo.css';

const DoctorAccountDeletionInfo = () => {
  const [successMessage, setSuccessMessage] = useState(false);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "ArogyaBee Doctor Pro – Account Deletion Request";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  const initialValues = {
    email: '',
  };

  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = 'Email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = 'Invalid email address';
    }
    return errors;
  };

  const handleSubmit = async (values) => {
    const body={
      email: values.email,
      accountType: 'doctor'
    }
   accountDeletion(body).then(res=>{
    console.log('res: ', res);
   }).catch(err => {console.log(err);})
    console.log('Form data:', values);
    setSuccessMessage(true);
  };

  return (
    <div className="form-container">
      {successMessage ? (
        <div className="success-container">
          <h2 className="success-title">Request Submitted Successfully!</h2>
          <p className="success-text">
            Your account deletion request has been received. A member of the eDigitizeYourself (eHomosapiens) team will contact you shortly.
          </p>
        </div>
      ) : (
        <>
          <div className="header-section">
            <img
              src={icon}
              alt="ArogyaBee Doctor Pro"
              className="company-logo"
            />
            <h1 className="company-name">ArogyaBee Doctor Pro</h1>
            <p className="owner-name">eDigitizeYourself (eHomosapiens)</p>
          </div>

          <h2 className="form-title">Account Deletion Request</h2>
          <p className="owner-name">A member of the eDigitizeYourself (eHomosapiens) team will reach out to you to assist with your request.</p>

          <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Email Address
                  </label>
                  <Field
                    type="email"
                    id="email"
                    name="email"
                    className="form-input"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="form-error"
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="form-button"
                >
                  Submit Request
                </button>
              </Form>
            )}
          </Formik>
        </>
      )}
    </div>
  );
};

export default DoctorAccountDeletionInfo;
